export enum PASSWORD_VALIDATION_ERRORS {
  required = 'Password is required',
  min = 'Password must be 7 symbols or more',
  oneNumber = 'Password requires at least one number',
  oneLowerCase = 'Password requires at least one lowercase letter',
  oneUpperCase = 'Password requires at least one uppercase letter',
  oneSymbol = 'Password requires at least one special symbol',
  checkRequired = 'You must enter your password a second time to verify',
  matching = 'Passwords must match',
}

export enum EMAIL_VALIDATION_ERRORS {
  required = 'Email is required',
  invalid = 'Invalid email address',
}

export enum EMAILED_CODE_VALIDATION_ERRORS {
  required = 'Verification code is required',
  invalid = 'Invalid verification code, expected 6 digits.',
}

export enum MFA_VALIDATION_ERRORS {
  required = 'A 6-digit MFA code is required to proceed',
  invalid = 'Invalid MFA code',
}

export enum PHONE_VALIDATION_ERRORS {
  required = 'Phone number is required',
  invalid = 'The data entered does not match the phone number template',
}

export enum FIRST_NAME_VALIDATION_ERRORS {
  required = 'First name is required',
  invalid = 'This field can only contain symbols that are common for names',
}

export enum LAST_NAME_VALIDATION_ERRORS {
  required = 'Last name is required',
  invalid = 'This field can only contain symbols that are common for names',
}

export enum ACCEPT_TERMS_VALIDATION_ERRORS {
  required = 'Required',
  invalid = 'You must accept the terms and conditions',
}

export enum ACCEPT_SMS_VALIDATION_ERRORS {
  required = 'Required',
  invalid = 'You must accept authentication via SMS',
}

export enum RELATION_TO_ACCOUNT_HOLDER_ERRORS {
  required = 'You must provide an indication as to your relationship',
  invalid = 'This field can only contain symbols that are common for a relationship description',
}

export enum NAME_VALIDATION_ERRORS {
  required = 'Your full name is required',
  invalid = 'First and last name should be provided',
}

export enum LIFE_EVENT_ERRORS {
  required = 'You must specify wether they are incapcitated or have passed away',
  invalid = 'This may only be incapcitated or passed away',
}

export enum LIFE_EVENT_KEY_ERRORS {
  required = 'You must provide the long-form key to register a life event',
  invalid = 'Key formart expected XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX',
}
